<template>
    <div class="p-30">
        <el-form class="mb-30">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="班级名称：">
                        <el-input v-model="className" placeholder="请输入班级名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="班群号：">
                        <el-input v-model="classNumber" placeholder="请输入班群号"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <div class="flex jc-fe">
                        <el-button type="primary" @click="search()">
                            <i class="el-icon-search" style="margin-right: 5px;"></i>查询
                        </el-button>
                        <el-button @click="search('refresh')">
                            <i class="el-icon-refresh" style="margin-right: 5px;"></i>重置
                        </el-button>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <el-button style="margin-bottom: 20px;" type="primary" plain icon="el-icon-plus" @click="addClass()">
            新增班级
        </el-button>
        <div v-for="(c, i) in classList" :key="i" @click="toDetail(c)" class="class-card pt-15 pb-15 mb-20 f-12">
            <div class="flex jc-sb c-9e9e9e pl-30 pr-30">
                <div>
                    <div class="flex jc-sb ai-fe mb-15">
                        <div class="c-000 f-18 mr-50">{{ c.className }}</div>
                        <div>
                            班群号：{{ c.classNumber }}
                            <i @click="copyToClipboard(c)" class="el-icon-document-copy"></i>
                        </div>
                    </div>
                    <div class="flex jc-sb">
                        <div class="mr-50">班级预设人数：{{ c.maxSize }}</div>
                        <div>已加入人数：{{ c.currentSize }}</div>
                    </div>
                </div>
                <div @click.stop="toClassInfo(c)">
                    <i class="el-icon-s-tools c-409eff"></i>
                    班级管理
                </div>
            </div>
            <div v-if="c.hasF" class="line-h mt-10 mb-10"></div>
            <div v-if="c.hasF" class="flex jc-sb c-9e9e9e pl-30 pr-30">
                <div>
                    <div class="flex jc-sb ai-fe mb-5">
                        <div class="c-000 f-18 mr-50">班级名称</div>
                        <div>
                            班群号：1234567
                            <i @click="copyToClipboard(c)" class="el-icon-document-copy"></i>
                        </div>
                    </div>
                    <div class="flex jc-sb">
                        <div class="mr-50">班级预设人数：</div>
                        <div>已加入人数：</div>
                    </div>
                </div>
                <div>
                    <i class="el-icon-s-tools c-409eff"></i>
                    班级管理
                </div>
            </div>
        </div>

        <el-empty v-if="classList && classList.length == 0" description="暂无数据"></el-empty>
        <el-pagination class="flex jc-fe" @size-change="pageSizeChange" @current-change="pageNoChange"
            :current-page="pageNo" :page-sizes="[10, 20, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
</template>

<script>
import { getClassList } from '@/api/index2';
import { encrypt, decrypt } from '@/api/common_encrypt';

export default {
    name: 'classList',
    components: {},
    computed: {

    },
    data() {
        return {
            loading: false,
            pageNo: 1,
            pageSize: 10,

            className: "",
            classNumber: "",
            searchForm: {},

            pageNo: 1,
            pageSize: 10,
            total: 0,

            classList: [],

        };
    },
    mounted() {
        this.getList();
    },

    methods: {

        pageNoChange(e) {
            this.pageNo = e;
            this.getList();
        },
        pageSizeChange(e) {
            this.pageSize = e;
            this.getList();
        },
        search(msg) {
            this.pageNo = 1;
            if (msg == "refresh") {
                this.searchForm = {};
                this.className = null;
                this.classNumber = null;
                // schoolId
            }
            this.searchForm = {
                className: this.className,
                classNumber: this.classNumber,
            }
            this.getList();
        },
        getList() {
            this.loading = true;
            let param = {
                needPage: true,
                page: this.pageNo,
                pageSize: this.pageSize,
                ...this.searchForm,
            };
            getClassList(param).then((res) => {
                if (res.result == 1) {
                    console.log('res :>> ', res);
                    this.classList = res.data.list;
                    this.total = res.data.total;
                    this.pageNo = res.data.pageNum;

                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
                this.loading = false;
            });
        },
        async copyToClipboard(c) {
            try {
                await navigator.clipboard.writeText(c.classNumber);
                this.$message({
                    message: '复制成功',
                    type: 'success'
                })
            } catch (err) {
                this.$message({
                    message: '复制失败',
                    type: 'warning'
                });
            }
        },

        toDetail(c) {
            let param = {
                classInfo: c
            }
            this.$router.push({
                path: '/classDetail',
                query: {
                    param: encrypt(JSON.stringify(param)),
                }
            });
        },

        toClassInfo(c) {
            let param = {
                classInfo: c
            }
            this.$router.push({
                path: '/classInfo',
                query: {
                    param: encrypt(JSON.stringify(param)),
                }
            });
        },

        addClass() {
            this.$router.push({
                path: '/addClass',
            });
        },

    }
};
</script>

<style lang='scss' scoped>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 0px;
}

.class-card {
    border-radius: 20px;
    border: 1px solid #ebeef5;
    transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.class-card:hover {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15);
    // transform: translateY(-1px);
}

.line-h {
    display: inline-block;
    height: 1px;
    width: 100%;
    background-color: #d8d8d8;
}
</style>
